import React from 'react';

const FeedbackWidget = ({
    uniqueKey,
    subtitle,
    title,
    likeLabel,
    dislikeLabel,
    ...otherProps
}) => {
    return (
        <button
            data-feature-feedback-link
            data-feature-feedback-key={uniqueKey}
            data-feature-feedback-subtitle={subtitle}
            data-feature-feedback-title={title}
            data-feature-feedback-likelabel={likeLabel}
            data-feature-feedback-dislikelabel={dislikeLabel}
            {...otherProps}
        />
    );
};

export default FeedbackWidget;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/messaging/feedback-widget.jsx